import React from 'react';
import "../App.css";
import { Link, useNavigate } from 'react-router-dom';
function LandingPage() {
    const router =useNavigate();
    return ( 
        <div className='landingpageContainer'>
            <nav>
                <div className='navheader'>
                    <h2>video Call</h2>
                    </div>
                <div className='navlist'>
                    <p onClick={()=>{
                     router("/taniya")
                    }}>Join as Guest</p>
                    <p onClick={() => {
                        router("/auth")

                    }}>Register</p>
                    <div  onClick={()=>{
                     router("/auth")
                    }} role='button'>
                        <p>Login</p>
                    </div>
                </div>
            </nav>
            {/* main container */}
            <div className="landingmainContainer">
                <div>
                    <h1><span style={{color:"#FF9839"}}>Connect</span> with your loved onces</h1>
                    <p>Cover a distance by video call</p>
                    <div role='button'>
                        <Link to={"/auth"}>Get started</Link>
                    </div>
                </div>
                <div>
                    <img src="/mobile.png" alt="" />
                </div>
            </div>
        </div>
     );
}

export default LandingPage;